import { render, staticRenderFns } from "./VaDoughnutChart.vue?vue&type=template&id=31081bb5&scoped=true&"
import script from "./VaDoughnutChart.vue?vue&type=script&lang=js&"
export * from "./VaDoughnutChart.vue?vue&type=script&lang=js&"
import style0 from "./VaDoughnutChart.vue?vue&type=style&index=0&id=31081bb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31081bb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31081bb5')) {
      api.createRecord('31081bb5', component.options)
    } else {
      api.reload('31081bb5', component.options)
    }
    module.hot.accept("./VaDoughnutChart.vue?vue&type=template&id=31081bb5&scoped=true&", function () {
      api.rerender('31081bb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/charts/VaDoughnutChart.vue"
export default component.exports